
/**
 * Base class for all Large containers which we can show.
 */
export default class LargeContainer {
    /**
     * Show this container.
     *
     * @returns Promise.
     */
    show() {
        return Promise.resolve();
    }

    /**
     * Hide this container.
     *
     * @returns Promise.
     */
    hide() {
        return Promise.resolve();
    }

    /**
     * Resize this container.
     *
     * @param {number} _containerWidth - Available width.
     * @param {number} _containerHeight - Available height.
     * @param {boolean} _animate - If container should animate it's resize process.
     */
    resize() {
        return undefined;
    }

    /**
     * Handler for "hover in" events.
     */
    onHoverIn() {
        return undefined;
    }

    /**
     * Handler for "hover out" events.
     */
    onHoverOut() {
        return undefined;
    }

    /**
     * Update video stream.
     *
     * @param {string} _userID
     * @param {MHTrack?} _stream - New stream.
     * @param {string} _videoType - Video type.
     */
    setStream() {
        return undefined;
    }

    /**
     * Show or hide user avatar.
     *
     * @param {boolean} _show
     */
    showAvatar() {
        return undefined;
    }

    /**
     * Whether current container needs to be switched on dominant speaker event
     * when the container is on stage.
     *
     * @returns {boolean}
     */
    stayOnStage() {
        return undefined;
    }
}
